<div class="info_box_outer">
  <div class="info_box">
    <h4>Enertics Inc</h4>
    <h6>Customer</h6>
  </div>
  <div class="info_box">
    <h4>Canada</h4>
    <h6>Site</h6>
  </div>
  <div class="info_box">
    <h4>GTA</h4>
    <h6>Application</h6>
  </div>
  <div class="info_box">
    <div class="inner">
      <div class="lft">
        <h4>enertics inc</h4>
        <h6>Machine Make</h6>
      </div>
      <div class="rgt" style="cursor: pointer">
        <img alt="User" class="thumb" src="assets/images/assets.png" />
      </div>
    </div>
  </div>
  <div class="info_box">
    <h4>ELMIN031023-00013</h4>
    <h6>Machine Serial Number</h6>
  </div>
</div>
